export default __webpack_public_path__ + "static/media/feedback-banner.586843b3.jpeg";